export class PageHeader {
  constructor() {
    this._elements = document.querySelectorAll(".s-page-header");
    this.init();
  }

  init() {
    if (!this._elements) return;

    this._elements.forEach((element) => {
      const explorer = element.querySelector(
        ".s-page-header-content__explorer",
      );

      explorer.addEventListener("click", () => {
        const nextSection = element.nextElementSibling;
        nextSection.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    });
  }
}
